// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/admin_survey.proto (package v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AnswerType } from "./survey_pb";
import { file_v1_survey } from "./survey_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/admin_survey.proto.
 */
export const file_v1_admin_survey: GenFile = /*@__PURE__*/
  fileDesc("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", [file_v1_survey]);

/**
 * AdminSurveyQuestionOption is one editable choice.
 * id is 0 for an option that does not exist yet.
 *
 * @generated from message v1.AdminSurveyQuestionOption
 */
export type AdminSurveyQuestionOption = Message<"v1.AdminSurveyQuestionOption"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string label = 2;
   */
  label: string;
};

/**
 * Describes the message v1.AdminSurveyQuestionOption.
 * Use `create(AdminSurveyQuestionOptionSchema)` to create a new message.
 */
export const AdminSurveyQuestionOptionSchema: GenMessage<AdminSurveyQuestionOption> = /*@__PURE__*/
  messageDesc(file_v1_admin_survey, 0);

/**
 * AdminSurveyQuestion is one editable question.
 * id is 0 for a question that does not exist yet.
 *
 * @generated from message v1.AdminSurveyQuestion
 */
export type AdminSurveyQuestion = Message<"v1.AdminSurveyQuestion"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: v1.AnswerType answer_type = 3;
   */
  answerType: AnswerType;

  /**
   * @generated from field: bool required = 4;
   */
  required: boolean;

  /**
   * @generated from field: repeated v1.AdminSurveyQuestionOption options = 5;
   */
  options: AdminSurveyQuestionOption[];
};

/**
 * Describes the message v1.AdminSurveyQuestion.
 * Use `create(AdminSurveyQuestionSchema)` to create a new message.
 */
export const AdminSurveyQuestionSchema: GenMessage<AdminSurveyQuestion> = /*@__PURE__*/
  messageDesc(file_v1_admin_survey, 1);

/**
 * AdminSurvey is the administrator view of a survey.
 *
 * @generated from message v1.AdminSurvey
 */
export type AdminSurvey = Message<"v1.AdminSurvey"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: v1.SurveyStatus status = 4;
   */
  status: SurveyStatus;

  /**
   * start_date and end_date are YYYY-MM-DD, or "" when unbounded.
   *
   * @generated from field: string start_date = 5;
   */
  startDate: string;

  /**
   * @generated from field: string end_date = 6;
   */
  endDate: string;

  /**
   * @generated from field: int32 frequency_days = 7;
   */
  frequencyDays: number;

  /**
   * @generated from field: int32 max_prompts = 8;
   */
  maxPrompts: number;

  /**
   * @generated from field: int32 response_count = 9;
   */
  responseCount: number;

  /**
   * @generated from field: repeated v1.AdminSurveyQuestion questions = 10;
   */
  questions: AdminSurveyQuestion[];
};

/**
 * Describes the message v1.AdminSurvey.
 * Use `create(AdminSurveySchema)` to create a new message.
 */
export const AdminSurveySchema: GenMessage<AdminSurvey> = /*@__PURE__*/
  messageDesc(file_v1_admin_survey, 2);

/**
 * @generated from message v1.ListSurveysRequest
 */
export type ListSurveysRequest = Message<"v1.ListSurveysRequest"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;
};

/**
 * Describes the message v1.ListSurveysRequest.
 * Use `create(ListSurveysRequestSchema)` to create a new message.
 */
export const ListSurveysRequestSchema: GenMessage<ListSurveysRequest> = /*@__PURE__*/
  messageDesc(file_v1_admin_survey, 3);

/**
 * @generated from message v1.ListSurveysResponse
 */
export type ListSurveysResponse = Message<"v1.ListSurveysResponse"> & {
  /**
   * surveys carry no questions in the list view; use GetSurvey for those.
   *
   * @generated from field: repeated v1.AdminSurvey surveys = 1;
   */
  surveys: AdminSurvey[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;

  /**
   * @generated from field: int32 current_page = 3;
   */
  currentPage: number;

  /**
   * @generated from field: int32 total_pages = 4;
   */
  totalPages: number;
};

/**
 * Describes the message v1.ListSurveysResponse.
 * Use `create(ListSurveysResponseSchema)` to create a new message.
 */
export const ListSurveysResponseSchema: GenMessage<ListSurveysResponse> = /*@__PURE__*/
  messageDesc(file_v1_admin_survey, 4);

/**
 * @generated from message v1.GetSurveyRequest
 */
export type GetSurveyRequest = Message<"v1.GetSurveyRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message v1.GetSurveyRequest.
 * Use `create(GetSurveyRequestSchema)` to create a new message.
 */
export const GetSurveyRequestSchema: GenMessage<GetSurveyRequest> = /*@__PURE__*/
  messageDesc(file_v1_admin_survey, 5);

/**
 * @generated from message v1.GetSurveyResponse
 */
export type GetSurveyResponse = Message<"v1.GetSurveyResponse"> & {
  /**
   * @generated from field: v1.AdminSurvey survey = 1;
   */
  survey?: AdminSurvey;
};

/**
 * Describes the message v1.GetSurveyResponse.
 * Use `create(GetSurveyResponseSchema)` to create a new message.
 */
export const GetSurveyResponseSchema: GenMessage<GetSurveyResponse> = /*@__PURE__*/
  messageDesc(file_v1_admin_survey, 6);

/**
 * @generated from message v1.CreateSurveyRequest
 */
export type CreateSurveyRequest = Message<"v1.CreateSurveyRequest"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: string start_date = 3;
   */
  startDate: string;

  /**
   * @generated from field: string end_date = 4;
   */
  endDate: string;

  /**
   * @generated from field: int32 frequency_days = 5;
   */
  frequencyDays: number;

  /**
   * @generated from field: int32 max_prompts = 6;
   */
  maxPrompts: number;

  /**
   * @generated from field: repeated v1.AdminSurveyQuestion questions = 7;
   */
  questions: AdminSurveyQuestion[];
};

/**
 * Describes the message v1.CreateSurveyRequest.
 * Use `create(CreateSurveyRequestSchema)` to create a new message.
 */
export const CreateSurveyRequestSchema: GenMessage<CreateSurveyRequest> = /*@__PURE__*/
  messageDesc(file_v1_admin_survey, 7);

/**
 * @generated from message v1.CreateSurveyResponse
 */
export type CreateSurveyResponse = Message<"v1.CreateSurveyResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: v1.AdminSurvey survey = 3;
   */
  survey?: AdminSurvey;
};

/**
 * Describes the message v1.CreateSurveyResponse.
 * Use `create(CreateSurveyResponseSchema)` to create a new message.
 */
export const CreateSurveyResponseSchema: GenMessage<CreateSurveyResponse> = /*@__PURE__*/
  messageDesc(file_v1_admin_survey, 8);

/**
 * @generated from message v1.UpdateSurveyRequest
 */
export type UpdateSurveyRequest = Message<"v1.UpdateSurveyRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string start_date = 4;
   */
  startDate: string;

  /**
   * @generated from field: string end_date = 5;
   */
  endDate: string;

  /**
   * @generated from field: int32 frequency_days = 6;
   */
  frequencyDays: number;

  /**
   * @generated from field: int32 max_prompts = 7;
   */
  maxPrompts: number;

  /**
   * questions replaces the whole list. For a non-draft survey the ids,
   * answer types and option ids must match what is stored; only labels and
   * the required flag may differ.
   *
   * @generated from field: repeated v1.AdminSurveyQuestion questions = 8;
   */
  questions: AdminSurveyQuestion[];
};

/**
 * Describes the message v1.UpdateSurveyRequest.
 * Use `create(UpdateSurveyRequestSchema)` to create a new message.
 */
export const UpdateSurveyRequestSchema: GenMessage<UpdateSurveyRequest> = /*@__PURE__*/
  messageDesc(file_v1_admin_survey, 9);

/**
 * @generated from message v1.UpdateSurveyResponse
 */
export type UpdateSurveyResponse = Message<"v1.UpdateSurveyResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: v1.AdminSurvey survey = 3;
   */
  survey?: AdminSurvey;
};

/**
 * Describes the message v1.UpdateSurveyResponse.
 * Use `create(UpdateSurveyResponseSchema)` to create a new message.
 */
export const UpdateSurveyResponseSchema: GenMessage<UpdateSurveyResponse> = /*@__PURE__*/
  messageDesc(file_v1_admin_survey, 10);

/**
 * @generated from message v1.UpdateSurveyStatusRequest
 */
export type UpdateSurveyStatusRequest = Message<"v1.UpdateSurveyStatusRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: v1.SurveyStatus status = 2;
   */
  status: SurveyStatus;
};

/**
 * Describes the message v1.UpdateSurveyStatusRequest.
 * Use `create(UpdateSurveyStatusRequestSchema)` to create a new message.
 */
export const UpdateSurveyStatusRequestSchema: GenMessage<UpdateSurveyStatusRequest> = /*@__PURE__*/
  messageDesc(file_v1_admin_survey, 11);

/**
 * @generated from message v1.UpdateSurveyStatusResponse
 */
export type UpdateSurveyStatusResponse = Message<"v1.UpdateSurveyStatusResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: v1.AdminSurvey survey = 3;
   */
  survey?: AdminSurvey;
};

/**
 * Describes the message v1.UpdateSurveyStatusResponse.
 * Use `create(UpdateSurveyStatusResponseSchema)` to create a new message.
 */
export const UpdateSurveyStatusResponseSchema: GenMessage<UpdateSurveyStatusResponse> = /*@__PURE__*/
  messageDesc(file_v1_admin_survey, 12);

/**
 * @generated from message v1.DeleteSurveyRequest
 */
export type DeleteSurveyRequest = Message<"v1.DeleteSurveyRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message v1.DeleteSurveyRequest.
 * Use `create(DeleteSurveyRequestSchema)` to create a new message.
 */
export const DeleteSurveyRequestSchema: GenMessage<DeleteSurveyRequest> = /*@__PURE__*/
  messageDesc(file_v1_admin_survey, 13);

/**
 * @generated from message v1.DeleteSurveyResponse
 */
export type DeleteSurveyResponse = Message<"v1.DeleteSurveyResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message v1.DeleteSurveyResponse.
 * Use `create(DeleteSurveyResponseSchema)` to create a new message.
 */
export const DeleteSurveyResponseSchema: GenMessage<DeleteSurveyResponse> = /*@__PURE__*/
  messageDesc(file_v1_admin_survey, 14);

/**
 * @generated from message v1.GetSurveyResultsRequest
 */
export type GetSurveyResultsRequest = Message<"v1.GetSurveyResultsRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message v1.GetSurveyResultsRequest.
 * Use `create(GetSurveyResultsRequestSchema)` to create a new message.
 */
export const GetSurveyResultsRequestSchema: GenMessage<GetSurveyResultsRequest> = /*@__PURE__*/
  messageDesc(file_v1_admin_survey, 15);

/**
 * SurveyOptionResult is one choice's tally for a radio or checkbox question.
 *
 * @generated from message v1.SurveyOptionResult
 */
export type SurveyOptionResult = Message<"v1.SurveyOptionResult"> & {
  /**
   * @generated from field: int32 option_id = 1;
   */
  optionId: number;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: int32 count = 3;
   */
  count: number;

  /**
   * percentage is count divided by the question's answered responses, 0-100,
   * already rounded to one decimal place by the server.
   *
   * @generated from field: double percentage = 4;
   */
  percentage: number;
};

/**
 * Describes the message v1.SurveyOptionResult.
 * Use `create(SurveyOptionResultSchema)` to create a new message.
 */
export const SurveyOptionResultSchema: GenMessage<SurveyOptionResult> = /*@__PURE__*/
  messageDesc(file_v1_admin_survey, 16);

/**
 * SurveyTextAnswer is one free-text answer with its author.
 *
 * @generated from message v1.SurveyTextAnswer
 */
export type SurveyTextAnswer = Message<"v1.SurveyTextAnswer"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message v1.SurveyTextAnswer.
 * Use `create(SurveyTextAnswerSchema)` to create a new message.
 */
export const SurveyTextAnswerSchema: GenMessage<SurveyTextAnswer> = /*@__PURE__*/
  messageDesc(file_v1_admin_survey, 17);

/**
 * SurveyQuestionResult is one question's tally.
 *
 * @generated from message v1.SurveyQuestionResult
 */
export type SurveyQuestionResult = Message<"v1.SurveyQuestionResult"> & {
  /**
   * @generated from field: int32 question_id = 1;
   */
  questionId: number;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: v1.AnswerType answer_type = 3;
   */
  answerType: AnswerType;

  /**
   * options is populated for radio and checkbox questions.
   *
   * @generated from field: repeated v1.SurveyOptionResult options = 4;
   */
  options: SurveyOptionResult[];

  /**
   * text_answers is populated for text questions.
   *
   * @generated from field: repeated v1.SurveyTextAnswer text_answers = 5;
   */
  textAnswers: SurveyTextAnswer[];
};

/**
 * Describes the message v1.SurveyQuestionResult.
 * Use `create(SurveyQuestionResultSchema)` to create a new message.
 */
export const SurveyQuestionResultSchema: GenMessage<SurveyQuestionResult> = /*@__PURE__*/
  messageDesc(file_v1_admin_survey, 18);

/**
 * SurveyResponseSummary is one user's participation record.
 *
 * @generated from message v1.SurveyResponseSummary
 */
export type SurveyResponseSummary = Message<"v1.SurveyResponseSummary"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * submitted_at is YYYY-MM-DD HH:MM in Vietnam local time.
   *
   * @generated from field: string submitted_at = 2;
   */
  submittedAt: string;
};

/**
 * Describes the message v1.SurveyResponseSummary.
 * Use `create(SurveyResponseSummarySchema)` to create a new message.
 */
export const SurveyResponseSummarySchema: GenMessage<SurveyResponseSummary> = /*@__PURE__*/
  messageDesc(file_v1_admin_survey, 19);

/**
 * @generated from message v1.GetSurveyResultsResponse
 */
export type GetSurveyResultsResponse = Message<"v1.GetSurveyResultsResponse"> & {
  /**
   * @generated from field: v1.AdminSurvey survey = 1;
   */
  survey?: AdminSurvey;

  /**
   * @generated from field: int32 response_count = 2;
   */
  responseCount: number;

  /**
   * @generated from field: int32 total_user_count = 3;
   */
  totalUserCount: number;

  /**
   * response_rate is response_count/total_user_count as 0-100, one decimal
   * place. 0 when total_user_count is 0.
   *
   * @generated from field: double response_rate = 4;
   */
  responseRate: number;

  /**
   * @generated from field: repeated v1.SurveyQuestionResult questions = 5;
   */
  questions: SurveyQuestionResult[];

  /**
   * @generated from field: repeated v1.SurveyResponseSummary responses = 6;
   */
  responses: SurveyResponseSummary[];
};

/**
 * Describes the message v1.GetSurveyResultsResponse.
 * Use `create(GetSurveyResultsResponseSchema)` to create a new message.
 */
export const GetSurveyResultsResponseSchema: GenMessage<GetSurveyResultsResponse> = /*@__PURE__*/
  messageDesc(file_v1_admin_survey, 20);

/**
 * SurveyStatus mirrors the survey.status enum column.
 *
 * @generated from enum v1.SurveyStatus
 */
export enum SurveyStatus {
  /**
   * @generated from enum value: SURVEY_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SURVEY_STATUS_DRAFT = 1;
   */
  DRAFT = 1,

  /**
   * @generated from enum value: SURVEY_STATUS_ACTIVE = 2;
   */
  ACTIVE = 2,

  /**
   * @generated from enum value: SURVEY_STATUS_CLOSED = 3;
   */
  CLOSED = 3,
}

/**
 * Describes the enum v1.SurveyStatus.
 */
export const SurveyStatusSchema: GenEnum<SurveyStatus> = /*@__PURE__*/
  enumDesc(file_v1_admin_survey, 0);

/**
 * AdminSurveyService exposes administrator-only survey authoring and results.
 * The user-facing read and submit path lives in SurveyService.
 *
 * @generated from service v1.AdminSurveyService
 */
export const AdminSurveyService: GenService<{
  /**
   * @generated from rpc v1.AdminSurveyService.ListSurveys
   */
  listSurveys: {
    methodKind: "unary";
    input: typeof ListSurveysRequestSchema;
    output: typeof ListSurveysResponseSchema;
  },
  /**
   * @generated from rpc v1.AdminSurveyService.GetSurvey
   */
  getSurvey: {
    methodKind: "unary";
    input: typeof GetSurveyRequestSchema;
    output: typeof GetSurveyResponseSchema;
  },
  /**
   * @generated from rpc v1.AdminSurveyService.CreateSurvey
   */
  createSurvey: {
    methodKind: "unary";
    input: typeof CreateSurveyRequestSchema;
    output: typeof CreateSurveyResponseSchema;
  },
  /**
   * @generated from rpc v1.AdminSurveyService.UpdateSurvey
   */
  updateSurvey: {
    methodKind: "unary";
    input: typeof UpdateSurveyRequestSchema;
    output: typeof UpdateSurveyResponseSchema;
  },
  /**
   * @generated from rpc v1.AdminSurveyService.UpdateSurveyStatus
   */
  updateSurveyStatus: {
    methodKind: "unary";
    input: typeof UpdateSurveyStatusRequestSchema;
    output: typeof UpdateSurveyStatusResponseSchema;
  },
  /**
   * @generated from rpc v1.AdminSurveyService.DeleteSurvey
   */
  deleteSurvey: {
    methodKind: "unary";
    input: typeof DeleteSurveyRequestSchema;
    output: typeof DeleteSurveyResponseSchema;
  },
  /**
   * @generated from rpc v1.AdminSurveyService.GetSurveyResults
   */
  getSurveyResults: {
    methodKind: "unary";
    input: typeof GetSurveyResultsRequestSchema;
    output: typeof GetSurveyResultsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_admin_survey, 0);

